import React, { useEffect, useCallback } from "react";
import { Card, Row, Col, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { TransactionListData } from "./TransactionListData/TransactionListData";
import { addPayout, getPayoutList } from "../../actions/payout/";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useState } from "react";
import AddPayoutModal from "../../components/Modals/addPayout/addPayoutModal";
import { UTCtoLocalDateTime } from "utility/dateTimeUtils";

export const TransactionDetails = (props) => {
    const {
        rideId,
        rideDetails,
        payoutList,
        addPayout,
        currentUser,
        getPayoutList
    } = props;

    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        if (rideId && getPayoutList) {
            getPayoutList(rideId);
        }
    }, [rideId, getPayoutList]);


    const payoutData = payoutList?.data || payoutList || {};

    const summaryData = {
        totalAmountCollected: payoutData.totalAmountCollected || 0,
        platformFee: (payoutData.platformFee * payoutData.totalAmountCollected) || 0,
        netAmountPayable: payoutData.netAmountPayable || 0,
        amountSettled: payoutData.amountSettled || 0,
        currentBalance: (payoutData.netAmountPayable - payoutData.amountSettled) || 0,
    };

    const formatCurrency = (amount) => {
        return `Rs. ${amount.toLocaleString('en-IN')}`;
    };

    const transformedTransactions = (payoutData.payoutHistory || []).map(payout => ({
        key: payout.id || payout.payoutOrderId,
        payoutDate: `${UTCtoLocalDateTime(payout.createdAt).date}, ${UTCtoLocalDateTime(payout.createdAt).time}`,
        transactionId: payout.payoutOrderId,
        payMode: payout.payoutMode,
        status: payout.payoutStatus === "SUCCESS" ? "Success" :
            payout.payoutStatus === "FAILED" ? "Failed" : payout.payoutStatus,
        amountPaid: formatCurrency(payout.paidAmount)
    }));

    const handleAddPayout = async (payoutData) => {
        try {
            const result = await addPayout(rideId, payoutData);

            if (result && result.success) {
                setModalVisible(false);
                if (getPayoutList) {
                    getPayoutList(rideId);
                }
                return { success: true, data: result.data };
            } else {
                return { success: false, error: result?.error || "Failed to add payout" };
            }
        } catch (error) {
            return { success: false, error: error.message || "An error occurred while adding payout" };
        }
    };

    const handleButtonClick = () => {
        setModalVisible(true);
    };

    const summaryCardStyles = {
        borderRadius: "12px",
        border: "1px solid #e2e2e2",
        height: "84px",
    }

    const summaryCardTitleStyles = {
        color: "#000",
        fontSize: "16px",
        fontWeight: "400",
    }

    const summaryCardDataStyles = {
        fontSize: "24px",
        fontWeight: "700",
        color: "#000",
    }

    return (
        <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "space-between", textAlign: "center" }}>
                <Row gutter={[16, 16]}>
                    <Col span={8}>
                        <Card
                            bodyStyle={{ padding: "12px" }}
                            style={summaryCardStyles}
                        >
                            <div>
                                <div style={summaryCardTitleStyles}>
                                    Total Amount Collected
                                </div>
                                <div style={summaryCardDataStyles}>
                                    {formatCurrency(summaryData.totalAmountCollected)}
                                </div>
                            </div>
                        </Card>
                    </Col>

                    <Col span={8}>
                        <Card
                            bodyStyle={{ padding: "12px" }}
                            style={summaryCardStyles}
                        >
                            <div>
                                <div style={summaryCardTitleStyles}>
                                    Platform Fee
                                </div>
                                <div style={summaryCardDataStyles}>
                                    {formatCurrency(summaryData.platformFee)}
                                </div>
                            </div>
                        </Card>
                    </Col>

                    <Col span={8}>
                        <Card
                            bodyStyle={{ padding: "12px" }}
                            style={summaryCardStyles}
                        >
                            <div>
                                <div style={summaryCardTitleStyles}>
                                    Net Amount Payable
                                </div>
                                <div style={summaryCardDataStyles}>
                                    {formatCurrency(summaryData.netAmountPayable)}
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>


                <Row gutter={[16, 16]} style={{ marginBottom: "2px" }}>
                    <Col span={12}>
                        <Card
                            bodyStyle={{ padding: "12px" }}
                            style={summaryCardStyles}
                        >
                            <div>
                                <div style={summaryCardTitleStyles}>
                                    Amount Settled
                                </div>
                                <div style={summaryCardDataStyles}>
                                    {formatCurrency(summaryData.amountSettled)}
                                </div>
                            </div>
                        </Card>
                    </Col>

                    <Col span={12}>
                        <Card
                            bodyStyle={{ padding: "12px" }}
                            style={{
                                ...summaryCardStyles,
                                filter: summaryData.netAmountPayable === summaryData.amountSettled
                                    ? "grayscale(100%)"
                                    : "none",
                                opacity: summaryData.netAmountPayable === summaryData.amountSettled
                                    ? 0.5
                                    : 1,
                                backgroundColor: summaryData.netAmountPayable === summaryData.amountSettled
                                    ? "#f5f5f5"
                                    : "#fff",
                                borderColor: summaryData.netAmountPayable === summaryData.amountSettled
                                    ? "#d9d9d9"
                                    : "#e2e2e2"
                            }
                            }
                        >
                            <div>
                                <div style={summaryCardTitleStyles}>
                                    Current Balance
                                </div>
                                <div style={summaryCardDataStyles}>
                                    {formatCurrency(summaryData.currentBalance)}
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "10px 0px" }}>
                    <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                type="primary"
                                icon={<PlusOutlined fontSize={24} />}
                                onClick={handleButtonClick}
                                disabled={summaryData.netAmountPayable === summaryData.amountSettled}
                                style={{
                                    backgroundColor: summaryData.netAmountPayable === summaryData.amountSettled
                                        ? "#ccc"
                                        : "#6528D8",
                                    borderColor: summaryData.netAmountPayable === summaryData.amountSettled
                                        ? "#ccc"
                                        : "#6528D8",
                                    borderRadius: "6px",
                                    fontSize: "20px",
                                    height: "24px",
                                    fontWeight: "600",
                                    width: "284px",
                                    height: "48px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    filter: summaryData.netAmountPayable === summaryData.amountSettled
                                        ? "grayscale(100%)"
                                        : "none",
                                    opacity: summaryData.netAmountPayable === summaryData.amountSettled
                                        ? 0.6
                                        : 1
                                }}
                            >
                                Add Payout
                            </Button>
                        </div>

                        {summaryData.amountSettled === summaryData.totalAmountCollected && (
                            <div style={{
                                fontSize: "20px",
                                fontWeight: "800",
                                color: "#6528D8",
                                marginTop: "10px",
                            }}>
                                "No more pending payouts"
                            </div>
                        )}
                    </div>
                </div>

                <TransactionListData transactions={transformedTransactions} />

                <AddPayoutModal
                    open={modalVisible}
                    onClose={() => setModalVisible(false)}
                    onSubmit={handleAddPayout}
                    rideId={rideId}
                    rideDetails={rideDetails}
                    userId={currentUser}
                />
            </div>
        </div >
    );
};


function mapStateToProps(state) {
    const {
        Payout: { payoutList },
        Login: { currentUser },
    } = state;
    return {
        payoutList,
        currentUser
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPayoutList: bindActionCreators(getPayoutList, dispatch),
        addPayout: bindActionCreators(addPayout, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TransactionDetails);


